<template>
    <div :data-practice-unit-id="unitId" class="practice-container mb-20">
        <shadow-container v-if="loading">
            <LoaderBlock green-color style="min-height: 150px" />
        </shadow-container>

        <PracticeContent v-else />
    </div>
</template>

<script>
import PracticeContent from "./PracticeContent.vue"
import { SET_PRACTICE, SET_VIEWED_QUIZ, TOGGLE_AUTH } from "@components/Practice/shared/store/practice-mutations"
import { GET_LESSON } from "@components/Practice/shared/store/practice-actions"
import PracticeRepository from "@components/Practice/shared/repository/practice-repository"
import LoaderBlock from "@components/Loaders/LoaderBlock.vue"
import ShadowContainer from "@components/Containers/ShadowContainer.vue"

export default {
    props: {
        quizId: {
            type: Number,
            default: 0
        },
        lessonId: {
            type: Number,
            default: 0
        },
        courseId: {
            type: Number,
            default: 0
        },
        unitId: {
            type: Number,
            default: 0
        }
    },
    name: "PracticeContainer",
    components: { ShadowContainer, LoaderBlock, PracticeContent },
    data() {
        return {
            loading: false
        }
    },
    async created() {
        this.loading = true

        const payload = { lesson_id: this.lessonId, unit_id: this.unitId }

        this.$store.commit(TOGGLE_AUTH, true)
        await this.$store.dispatch(GET_LESSON, payload)

        const { data: quiz } = await PracticeRepository.quiz(Object.assign(payload, { quiz_id: this.quizId }))
        const { data: questions } = await PracticeRepository.questions(Object.assign(payload, { quiz_id: this.quizId }))

        const quizPayload = {
            ...quiz,
            questions
        }

        this.loading = false

        this.$store.commit(SET_VIEWED_QUIZ, quizPayload)

        this.$store.commit(SET_PRACTICE, {
            quiz: quizPayload,
            is_available: true,
            is_from_unit: true,
            unitId: this.unitId,
            course: {
                id: this.courseId
            },
            courseAccess: {
                is_product_on_sale: true,
                is_course_subscribed: true,
                is_course_available: true,
                is_course_blocked: false
            }
        })
    }
}
</script>

<style lang="sass" scoped>

</style>
